import { createStyles } from 'antd-style'

export const useStyle = createStyles(
  (
    _,
    props: {
      isActive?: boolean
    }
  ) => ({
    arrow: {
      marginTop: 6,
      transform: `rotate(${props?.isActive ? 180 : 0}deg)`,
      transition: '0.3s'
    }
  })
)
